// src/pages/TableCitoyens.jsx
import React from "react";
import Layout from "../components/Layout";
import TableUser from "../components/Admin/TableUser";

function TableUsers() {

  return (
    <Layout >
      <div className="p-6">
        <TableUser />
      </div>
    </Layout>
  );
}

export default TableUsers;
